import { PaletteFragmentFragment } from "src/api/graphql/__generated__/graphql";
import { PaletteOption } from "src/screens/(internal)/CustomThemeModal/types";

export const parsePalette = (palette?: PaletteFragmentFragment | null): PaletteOption | null => {
	if (!palette) return null;
	const { primary, secondary, tertiary } = palette;
	return primary && secondary && tertiary ? { primary, secondary, tertiary } : null;
};
